export const config = {
  localApiUrl: "https://upnup.org.uk",
};
